const LOGOS = [
  { name: 'Ahmet Kuaför', city: 'Ankara', icon: 'ri-scissors-2-line', color: '#f0b429' },
  { name: 'Selin Güzellik', city: 'İstanbul', icon: 'ri-hearts-line', color: '#f472b6' },
  { name: 'Dr. Mert Diş', city: 'İzmir', icon: 'ri-hospital-line', color: '#34d399' },
  { name: 'Özlem Pilates', city: 'Bursa', icon: 'ri-run-line', color: '#60a5fa' },
  { name: 'Kadir Oto Servis', city: 'Antalya', icon: 'ri-car-line', color: '#a78bfa' },
  { name: 'Pınar Nail Art', city: 'Eskişehir', icon: 'ri-brush-2-line', color: '#f87171' },
  { name: 'Tarık Hukuk', city: 'İstanbul', icon: 'ri-scales-3-line', color: '#fbbf24' },
  { name: 'Zeynep Psikoloji', city: 'Ankara', icon: 'ri-mental-health-line', color: '#6ee7b7' },
  { name: 'Emre Fotoğraf', city: 'Antalya', icon: 'ri-camera-3-line', color: '#93c5fd' },
  { name: 'Hande Diyet', city: 'İzmir', icon: 'ri-leaf-line', color: '#4ade80' },
  { name: 'Musa Mimarlık', city: 'Adana', icon: 'ri-building-2-line', color: '#e2b714' },
  { name: 'Ceylan Yoga', city: 'Bodrum', icon: 'ri-mental-health-line', color: '#c084fc' },
];

function LogoItem({ logo }: { logo: typeof LOGOS[0] }) {
  return (
    <div
      className="flex items-center gap-3 px-6 py-3 rounded-2xl flex-shrink-0 group cursor-default"
      style={{
        background: 'rgba(255,255,255,0.03)',
        border: '1px solid rgba(255,255,255,0.07)',
        transition: 'border-color 0.3s ease, background 0.3s ease',
      }}
      onMouseEnter={e => {
        (e.currentTarget as HTMLElement).style.background = 'rgba(255,255,255,0.06)';
        (e.currentTarget as HTMLElement).style.borderColor = `${logo.color}40`;
      }}
      onMouseLeave={e => {
        (e.currentTarget as HTMLElement).style.background = 'rgba(255,255,255,0.03)';
        (e.currentTarget as HTMLElement).style.borderColor = 'rgba(255,255,255,0.07)';
      }}
    >
      {/* Icon circle */}
      <div
        className="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0"
        style={{
          background: `${logo.color}18`,
          border: `1px solid ${logo.color}35`,
        }}
      >
        <i className={`${logo.icon} text-base`} style={{ color: logo.color }} />
      </div>

      {/* Name + city */}
      <div className="min-w-0">
        <div className="text-[13px] font-bold text-white/90 whitespace-nowrap leading-tight">{logo.name}</div>
        <div className="text-[10px] text-gray-600 whitespace-nowrap">{logo.city}</div>
      </div>
    </div>
  );
}

export default function LogosBand() {
  const doubled = [...LOGOS, ...LOGOS];

  return (
    <section
      className="relative py-10 overflow-hidden"
      style={{
        background: 'linear-gradient(180deg, #0a0a0f 0%, #111118 50%, #0a0a0f 100%)',
        borderTop: '1px solid rgba(255,255,255,0.04)',
        borderBottom: '1px solid rgba(255,255,255,0.04)',
      }}
    >
      <style>{`
        @keyframes logos-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .logos-track {
          display: flex;
          width: max-content;
          animation: logos-scroll 40s linear infinite;
          gap: 12px;
        }
        .logos-track:hover {
          animation-play-state: paused;
        }
      `}</style>

      {/* Fade edges */}
      <div className="absolute left-0 top-0 bottom-0 w-32 z-10 pointer-events-none"
        style={{ background: 'linear-gradient(90deg, #0a0a0f 0%, transparent 100%)' }} />
      <div className="absolute right-0 top-0 bottom-0 w-32 z-10 pointer-events-none"
        style={{ background: 'linear-gradient(270deg, #0a0a0f 0%, transparent 100%)' }} />

      {/* Header label */}
      <div className="relative z-10 text-center mb-6">
        <div className="inline-flex items-center gap-3">
          <div className="h-px w-12" style={{ background: 'linear-gradient(90deg, transparent, rgba(240,180,41,0.4))' }} />
          <span className="text-[11px] font-bold tracking-widest uppercase text-gray-500">
            Sisteme Geçen İşletmelerden Bazıları
          </span>
          <div className="h-px w-12" style={{ background: 'linear-gradient(90deg, rgba(240,180,41,0.4), transparent)' }} />
        </div>
      </div>

      {/* Scrolling logos */}
      <div className="overflow-hidden px-0">
        <div className="logos-track">
          {doubled.map((logo, idx) => (
            <LogoItem key={idx} logo={logo} />
          ))}
        </div>
      </div>

      {/* Bottom counter */}
      <div className="relative z-10 text-center mt-6 flex items-center justify-center gap-6">
        <div className="flex items-center gap-2">
          <span className="relative flex w-2 h-2">
            <span className="absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-60 animate-ping" />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-green-400" />
          </span>
          <span className="text-[12px] text-gray-500">
            <span className="text-white font-bold">100+</span> işletme platformumuzu kullanıyor
          </span>
        </div>
        <div className="w-px h-4 bg-white/10" />
        <div className="flex items-center gap-1.5">
          <i className="ri-map-pin-2-line text-gold text-xs" />
          <span className="text-[12px] text-gray-500">
            <span className="text-white font-bold">12+</span> şehirde aktif
          </span>
        </div>
        <div className="w-px h-4 bg-white/10" />
        <div className="flex items-center gap-1.5">
          <i className="ri-star-fill text-gold text-xs" />
          <span className="text-[12px] text-gray-500">
            Ortalama <span className="text-white font-bold">4.9/5</span> memnuniyet
          </span>
        </div>
      </div>
    </section>
  );
}
